// extracted by mini-css-extract-plugin
module.exports = {"InputSlider":"styles_InputSlider__3RwwT","Label":"styles_Label__uCn_U"};